import { ListItem } from '../../../ListItem'

import { RentalPortalApplicantsEligibilityFilterListItemContent } from './RentalPortalApplicantsEligibilityFilterListItemContent'

function RentalPortalApplicantsEligibilityFilterListItem(props) {
  return (
    <ListItem
      {...props}
      Content={RentalPortalApplicantsEligibilityFilterListItemContent}
    />
  )
}

export default RentalPortalApplicantsEligibilityFilterListItem
